import { Link } from 'react-router-dom';
import { featuredAnime } from '@/mocks/homeData';
import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredAnime.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const current = featuredAnime[currentSlide];

  return (
    <section className="relative h-[520px] md:h-[680px] w-full overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={current.cover}
          alt={current.title}
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full max-w-7xl mx-auto px-4 md:px-8 flex flex-col justify-center">
        <div className="max-w-2xl">
          {/* Tags */}
          <div className="flex items-center gap-2 mb-4">
            {current.tags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1 text-xs font-medium rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/20"
              >
                {tag}
              </span>
            ))}
            <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-500/80 text-white">
              {current.status}
            </span>
          </div>

          {/* Title */}
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-3 leading-tight">
            {current.title}
          </h1>
          <p className="text-sm md:text-base text-white/70 mb-2 font-medium">
            {current.titleEn}
          </p>

          {/* Description */}
          <p className="text-sm md:text-base text-white/80 max-w-lg mb-6 leading-relaxed line-clamp-2">
            {current.description}
          </p>

          {/* Meta */}
          <div className="flex flex-wrap items-center gap-4 md:gap-6 text-white/60 text-xs md:text-sm mb-8">
            <span className="flex items-center gap-1.5">
              <i className="ri-star-fill text-accent-500"></i>
              <strong className="text-white font-medium">{current.rating}</strong> 分
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-eye-line"></i>
              {current.views} 播放
            </span>
            <span>{current.episode}</span>
            <span>{current.studio}</span>
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <Link
              to={`/article/${current.id}`}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              立即观看
            </Link>
            <Link
              to={`/category/${current.category === '热血' ? 'reboot' : current.category === '冒险' ? 'reboot' : 'reboot'}`}
              className="inline-flex items-center gap-2 px-5 py-3 bg-white/10 backdrop-blur-sm text-white font-medium text-sm rounded-full border border-white/20 hover:bg-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              更多推荐
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Slide indicators */}
        <div className="absolute bottom-8 left-4 md:left-8 flex items-center gap-2">
          {featuredAnime.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentSlide(idx)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                idx === currentSlide
                  ? 'bg-white w-6'
                  : 'bg-white/40 hover:bg-white/70'
              }`}
              aria-label={`切换到第${idx + 1}张`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}